import Data from '../Api/Data'
import { Type } from 'class-transformer'
import TArticleDM from './TArticleDM'

export default class TInventoryTurnoverChartSourceDM extends Data {
	public static className = 'TInventoryTurnoverChartSourceDM'
	public static systemFields = [
	]

	TotalSalePrice?: number
	TotalStockPrice?: number
	Quantity?: number
	AverageBookValue?: number
	AverageAvailable?: number
	DateTo?: Date
	ConfigurationRID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	LastComputeDateBitCalc?: number
	ConfigurationAbbrCalc?: string
	ConfigurationNameCalc?: string
	TurnoverRatioCalc?: number
	SalesInventoryAverageDaysCalc?: number
	ProfitCalc?: number
	QuantityUMCalc?: number
	EffectiveComputeQuantityUMCalc?: number
	DayCountCalc?: number
	ChartValueCalc?: number
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}